import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import DrawerFilter from '@/store/components/DrawerFilter'
import Dashboard from '@/store/dashboard/Dashboard'
import Account from '@/store/account/Account'
import Notification from '@/store/account/Notification'
import Customer from '@/store/register/Customer'
import Employee from '@/store/register/Employee'
import Supplier from '@/store/register/Supplier'
import Service from '@/store/register/Service'
import Product from '@/store/register/Product'
import BillsToPay from '@/store/financial/BillsToPay'
import Revenue from '@/store/financial/Revenue'
import Stock from '@/store/stock/Stock'
import PurchaseOrder from '@/store/stock/PurchaseOrder'
import PurchaseEntry from '@/store/stock/PurchaseEntry'
import Login from '@/store/login/login'
import Cash from '@/store/cash/Cash'
import NewSales from '@/store/sales/NewSales'
import OrderService from '@/store/sales/OrderService'
import SelfServiceScreen from '@/store/sales/SelfServiceScreen'
import DeliveryCenter from '@/store/sales/DeliveryCenter'
import Sales from '@/store/sales/Sales'
import ReportCommission from '@/store/report/team/ReportCommission'
import ReportListCustomer from '@/store/report/customer/listCustomer'
import ReportScheduleList from '@/store/report/schedule/ReportScheduleList'
import ReportScheduleSummary from '@/store/report/schedule/ReportScheduleSummary'
import Offer from '@/store/marketing/offer/Offer'
import Report from '@/store/report/Report'
import CustomizeCommission from '@/store/salary_and_commission/CustomizeCommission'
import ReportAnticipation from '@/store/salary_and_commission/ReportAnticipation'
import PayProfessional from '@/store/salary_and_commission/PayProfessional'
import TurnoProgramado from '@/store/salary_and_commission/TurnoProgramado'
import ConfigGratuity from '@/store/system/config_gratuity/ConfigGratuity'
import VuexPersistence from 'vuex-persist'
import Card from '@/store/register/Card'
import BodyAssessment from '@/store/aesthetics/BodyAssessment'
import CommissionSummary from '@/store/report/team/CommissionSummary'
import ConfigCompany from '@/store/configuration/ConfigCompany'
import ConfigSchedule from '@/store/configuration/ConfigSchedule'
import CashFlow from '@/store/financial/CashFlow'
import CashFlowReport from '@/store/financial/CashFlowReport'
import PointControl from '@/store/salary_and_commission/PointControl'
import TeamConfig from '@/store/system/team_config/TeamConfig'
import AccessControl from '@/store/configuration/AccessControl'
import LeaveTypes from '@/store/configuration/LeaveTypes'
import PaymentMethods from '@/store/configuration/PaymentMethods'
import ConfigSelfServiceScreen from '@/store/configuration/ConfigSelfServiceScreen'
import ConfigProfessionalActivity from '@/store/configuration/ConfigProfessionalActivity'
import ConfigDelivery from '@/store/configuration/ConfigDelivery'
import Pricing from '@/store/Pricing/Pricing'
import DailySales from '@/store/sales/DailySales'
import Vue from 'vue'
import Vuex from 'vuex'
import Calendar from './calendar/Calendar'
import PaymentsSales from './sales/PaymentsSales'
import LandingPage from './landingpage/LandingPage'
import app from './app'
import Invoice from './sales/Invoice'
import ScheduleCustomer from './schedule_customer/ScheduleCustomer'
import ReportStockAvailable from './report/stock/ReportStockAvailable'
import ReportStockProductList from './report/stock/ReportStockProductsList'
import ReportStockOrder from './report/stock/ReportStockOrder'
import ReportStockMovementSummary from './report/stock/ReportStockMovementSummary'
import ReportStockMovementRegister from './report/stock/ReportStockMovementRegister'
import ReportSummaryScheduleCancelled from './report/schedule/ReportSummaryScheduleCancelled'
import ReportSummarySale from './report/sale/ReportSummarySale'
import ReportListSale from './report/sale/ReportListSale'
import ReportSummaryPayment from './report/financial/ReportSummaryPayment'
import ReportPayment from './report/financial/ReportPayment'
import ReportSummaryFinancial from './report/financial/ReportSummaryFinancial'
import ReportHistoricHoursWorked from './report/team/ReportHistoricHoursWorked'
import ReportSalaryDetails from './report/team/ReportSalaryDetails'
import ReportSummarySalary from './report/team/ReportSummarySalary'
import ReportScheduledShift from './report/team/ReportScheduledShift'
import ReportSummaryFrequency from './report/team/ReportSummaryFrequency'
import ReportSummaryGratuity from './report/team/ReportSummaryGratuity'
import ReportSummaryPaymentEmployee from './report/team/ReportSummaryPaymentEmployee'
import ReportGratuity from './report/team/ReportGratuity'
import ReportSummaryProductivity from './report/team/ReportSummaryProductivity'
import ReportSlack from './report/team/ReportSlack'
import InvoiceNfe from './financial/Invoice'
import ReportPerformancePanel from './report/panel/PerformancePanel'
import DrawerHelper from './components/DrawerHelper'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    Dashboard,
    DrawerFilter,
    Account,
    Notification,
    app,
    Customer,
    Employee,
    Supplier,
    Service,
    Product,
    Card,
    BodyAssessment,
    BillsToPay,
    Revenue,
    Stock,
    Cash,
    NewSales,
    Sales,
    Invoice,
    Report,
    ReportCommission,
    ConfigGratuity,
    Login,
    PaymentsSales,
    CustomizeCommission,
    ReportAnticipation,
    PayProfessional,
    TurnoProgramado,
    Calendar,
    CommissionSummary,
    ReportListCustomer,
    ReportScheduleList,
    ReportScheduleSummary,
    Offer,
    OrderService,
    SelfServiceScreen,
    DeliveryCenter,
    PurchaseOrder,
    PurchaseEntry,
    ConfigCompany,
    ConfigSchedule,
    CashFlow,
    CashFlowReport,
    PointControl,
    TeamConfig,
    LandingPage,
    AccessControl,
    LeaveTypes,
    PaymentMethods,
    ConfigSelfServiceScreen,
    ConfigProfessionalActivity,
    ConfigDelivery,
    Pricing,
    DailySales,
    ScheduleCustomer,
    ReportStockAvailable,
    ReportStockProductList,
    ReportStockOrder,
    ReportStockMovementSummary,
    ReportStockMovementRegister,
    ReportSummaryScheduleCancelled,
    ReportSummarySale,
    ReportListSale,
    ReportSummaryPayment,
    ReportPayment,
    ReportSummaryFinancial,
    ReportHistoricHoursWorked,
    ReportSalaryDetails,
    ReportSummarySalary,
    ReportScheduledShift,
    ReportSummaryFrequency,
    ReportSummaryGratuity,
    ReportGratuity,
    ReportSummaryProductivity,
    ReportSlack,
    ReportPerformancePanel,
    ReportSummaryPaymentEmployee,
    InvoiceNfe,
    DrawerHelper
  },
  plugins: [
    new VuexPersistence({
      modules: ['appConfig', 'Login', 'app'],
    }).plugin,
  ],
})
